import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { validatePasswordResetCodeForm } from "../../../utils/validators/PasswordResetCodeFormValidator";
import { useSignInContext } from "../../../hooks/sign-in/SignInContext";
import { INITIAL_FIELD } from "../../../utils/FieldValidators";
const PasswordResetCodeForm = ({
  children,
  onPasswordResetComplete
}) => {
  const {
    email,
    confirmPassword,
    forgotPasswordError,
    loading,
    clearErrors,
    forgotPassword
  } = useSignInContext();
  const [registrationCode, setRegistrationCode] = React.useState(INITIAL_FIELD);
  const [password, setPassword] = React.useState(INITIAL_FIELD);
  const onFormSubmit = () => {
    confirmPassword(registrationCode.value, password.value, onPasswordResetComplete);
  };
  const handleChangePassword = value => {
    setPassword({
      value,
      pristine: false
    });
  };
  const handleChangeRegistrationCode = value => {
    setRegistrationCode({
      value,
      pristine: false
    });
  };
  const {
    fieldErrors,
    isFormInvalid,
    userErrorMessage
  } = validatePasswordResetCodeForm({
    password,
    registrationCode
  }, forgotPasswordError, true);
  return children({
    email,
    registrationCode,
    password,
    fieldErrors,
    isFormInvalid,
    userErrorMessage,
    onPasswordChange: handleChangePassword,
    onRegistrationCodeChange: handleChangeRegistrationCode,
    onFormSubmit,
    clearAuthError: clearErrors,
    loading,
    resendForgotPassword: forgotPassword
  });
};
export default PasswordResetCodeForm;
PasswordResetCodeForm.propTypes = {
  children: PropTypes.func.isRequired,
  onPasswordResetComplete: PropTypes.func.isRequired
};